import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Student } from '../models/student';
import { StudentService } from '../services/student.service';

@Component({
    selector: 'app-new-student',
    templateUrl: './new-student.component.html',
    styleUrls: ['./new-student.component.css'],
    standalone: false
})
export class NewStudentComponent implements OnInit {

  sectionId: string = '';
  studentId: string = '';
  student: Student;

  constructor(
    public dialogRef: MatDialogRef<NewStudentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private studentService: StudentService
  ) {
    this.sectionId = data.sectionId;
    this.studentId = data.studentId;
  }

  async ngOnInit() {
    console.log(this.studentId);
    if (this.studentId == '') {
      this.student = new Student();
    }
    else
    {
      this.student = await this.studentService.readByIdAsync(this.sectionId, this.studentId);

      //Version Anterior
      // this.db.doc<Student>('sections/' + this.sectionId + '/students/' + this.studentId)
      //   .valueChanges()
      //   .subscribe(a => {
      //     this.student = a;
      //   });
    }
  }

  async save() {

    if (this.studentId == '') {

      await this.studentService.createAsync(this.sectionId, this.student);

      // this.db.collection<Student>('sections/' + this.sectionId + '/students')
      //   .add({
      //     name: this.student.name,
      //     fatherName: this.student.fatherName,
      //     motherName: this.student.motherName
      //   });
    }
    else {

      await this.studentService.update(this.sectionId, this.studentId, this.student);

      //Version Anterior
      // this.db.doc<Student>('sections/' + this.sectionId + '/students/' + this.studentId)
      //   .update({
      //     name: this.student.name,
      //     fatherName: this.student.fatherName,
      //     motherName: this.student.motherName
      //   });

    }
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(true);
  }

}
